/* eslint-disable max-lines-per-function */
import { Button, buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useState } from 'react';
import { Link } from 'react-router-dom';

export function YearMonthPopoverContent({
  selectedDate,
  buildUrl,
  setIsOpen,
}: {
  selectedDate: Date;
  buildUrl: (selectedDate: Date) => string;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const [currentYear, setCurrentYear] = useState(
    dayjs(selectedDate).get('year'),
  );
  const selectedMonth = dayjs(selectedDate).get('month');

  const handlePrevYear = () => setCurrentYear((year) => year - 1);
  const handleNextYear = () => setCurrentYear((year) => year + 1);

  const monthNames = Array.from({ length: 12 }, (_, idx) =>
    dayjs().locale('de').month(idx).format('MMM').slice(0, 3),
  );

  function getUrl(monthIndex: number) {
    const selectedDate = dayjs()
      .year(currentYear)
      .month(monthIndex)
      .date(1)
      .toDate();
    return buildUrl(selectedDate);
  }

  return (
    <div className="flex flex-col items-center gap-3">
      <div className="flex w-full items-center justify-between">
        <Button onClick={handlePrevYear} variant="ghost-primary" size="icon">
          <FontAwesomeIcon icon={faChevronLeft} />
        </Button>
        <div className="text-sm font-semibold">{currentYear}</div>
        <Button onClick={handleNextYear} size="icon" variant="ghost-primary">
          <FontAwesomeIcon icon={faChevronRight} />
        </Button>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {monthNames.map((monthName, idx) => {
          const isSelected =
            currentYear === dayjs(selectedDate).get('year') &&
            selectedMonth === idx;
          return (
            <Link
              to={getUrl(idx)}
              key={idx}
              onClick={() => setIsOpen(false)}
              className={cn(
                buttonVariants({
                  size: 'sm',
                  variant: isSelected ? 'default' : 'ghost',
                }),
                'font-normal',
              )}>
              {monthName}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
